import {
  _getOSSsignature,
  _getOSSsignatureRam,
  _findAppInfoById
} from '@/api/Common'
import {
  _sendLoginOut
} from '@/api/UserLogin'
import {
  catchErr
} from '@/utils/utils'
import {
  Message
} from 'element-ui'
import router from '@/router'


export async function sendLoginOut({
  commit,
  state
}) {
  let [err, res] = await catchErr(_sendLoginOut());
  if (err) {
    Message.error(err || "错了哦，系统异常");
  } else if (res) {
    window.sessionStorage.setItem("binyi_cms_loginInfo", "");
    router.replace({
      path: "/userlogin"
    });
  }

}

export default {
  // 获取OSS上传签名
  async getOSSsignature({
    commit,
    state
  }, path) {
    let [err, res] = await catchErr(_getOSSsignature({
      data: path
    }));
    if (err) {
      Message.error('系统异常,请检查网络');
      return false;
    } else if (res) {
      commit('SETOPTIONS', {
        OSSINFO: res.data
      });
      return true;
    };
  },

  async getOSSsignatureAnother({
    commit,
    state
  }, params) {
    let [err, res] = await catchErr(_getOSSsignatureRam({
      data: params.path
    }));
    if (err) {
      Message.error('系统异常,请检查网络');
      return false;
    } else if (res) {
      console.log(res)
      res.data.index = params.index
      res.data.createTime = params.createTime
      res.data.itemNow = params.item
      commit('SETOPTIONS', {
        OSSINFONew: res.data
      });
      commit('SETOPTIONSFILENAME', params.timestamp);
      return true;
    };
  },

  
  async getOSSsignatureAgain({
    commit,
    state
  }, params) {
    let [err, res] = await catchErr(_getOSSsignatureRam({
      data: params.path
    }));
    if (err) {
      //Message.error(err || '系统异常');
      return false;
    } else if (res) {
      return res;
    };
  },

  // 退出登录
  async sendLoginOut({}) {
    let [err, res] = await catchErr(_sendLoginOut());
    if (err) {
      Message.error(err || "错了哦，系统异常");
    } else if (res) {
      window.sessionStorage.clear();
      router.replace({
        path: "/userlogin"
      });
    }

  },

  // // 获取单位信息
  // async findAppInfoById({
  //   commit,
  //   state
  // },id) {
  //   let [err, res] = await catchErr(_findAppInfoById({
  //     data:id
  //   }));
  //   if (err) {
  //     this.$message.error(err || "错了哦，系统异常");
  //   } else if (res) {
  //     commit("CURRENTUNIT",res.data.appName)
  //   }

  // }

}



// WEBPACK FOOTER //
// ./src/store/modules/Common/actions.js